import { render, staticRenderFns } from "./GroupSideNav.vue?vue&type=template&id=a90bf048"
import script from "./GroupSideNav.vue?vue&type=script&lang=js"
export * from "./GroupSideNav.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/group_dashboard/group_sidenav.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports